module.exports = __webpack_public_path__ + "img/xy_cn.24e3053.png";